import React from "react";
import { useLocation } from "react-router-dom";

import { UserContext } from "../App";

import NotApprovedBanner from "../components/NotApprovedBanner";
import PageLoadingSpinner from "../components/widgets/PageLoadingSpinner";
import { resolveAccess } from "../services/rbacService";

export const RouteGuard = ({ auth, children }) => {
  const [approved, setApproved] = React.useState<boolean | "loading">(
    "loading"
  );
  const _location = useLocation();
  const user = React.useContext(UserContext);

  const _userAccessLevel = resolveAccess(user?.saccoUser, _location.pathname);

  React.useEffect(() => {
    if (user?.saccoUser?.verified) {
      return setApproved(true);
    }
    setApproved(false);
  }, [user]);

  return auth &&
    (approved !== "loading" || _location.pathname === "/profile") ? (
    <>
      {user?.saccoUser.role ? (
        <>
          {approved === true && _userAccessLevel.allowedPage ? (
            children
          ) : (
            <NotApprovedBanner
              message={
                approved === true
                  ? "Sorry you are not allowed to access this page."
                  : ""
              }
            />
          )}
        </>
      ) : (
        <NotApprovedBanner />
      )}
    </>
  ) : (
    <PageLoadingSpinner />
  );
};
